import React from 'react';
import getAllDataInParallel from '../../helpers/get-all-data-in-parallel'
import SkuQuotaMastersContext from './sku-quota-masters-context';
import { fetchSkuQuotaMasters } from './sku-quota-masters-api';

export default function SkuQuotaMastersProvider({children}) {

  function fetchSkuQuotaMastersAll(params) {
    return getAllDataInParallel({
      fn: (args) => fetchSkuQuotaMasters({
        ...params,
        ...args,
      }),
      key: 'skuQuotaMasters',
    })
  }

  const state = {
    fetchSkuQuotaMasters,
    fetchSkuQuotaMastersAll,
  };

  return (
    <SkuQuotaMastersContext.Provider value={state}>
      {children}
    </SkuQuotaMastersContext.Provider>
  )
};
